var _module_exports = "<kubernetes-stack-logs-view get-logs-fn=\"ctrl.getStackLogsAsync\"> </kubernetes-stack-logs-view>\n";;
var path = 'app/kubernetes/views/stacks/logs/logs.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;